import "./Modals.scss";

const AfterModal = ({ showModal, modalTitle, modalText }) => {
  return (
    <div className="modalsWrapper">
      <div className="backdrop" onClick={() => showModal(false)}></div>

      <div className="modalsContainer">
        <div className="header">
          <p className="modalTitle">{modalTitle}</p>
          <button className="closeButton" onClick={() => showModal(false)}>
            <img src="/close.png" alt="X" />
          </button>
        </div>

        <p className="modalText">{modalText}</p>

        <div className="buttonBlock">
          <button onClick={() => showModal(false)}>Done</button>
        </div>
      </div>
    </div>
  );
};

export default AfterModal;
